import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.css']
})
export class PdfViewerComponent implements OnInit {
  @Input() pdfSrc: any;
  constructor() { }
  ngOnInit() {
    console.log(this.pdfSrc)
  }
}



// WEBPACK FOOTER //
// ./public/app/common/pdf-viewer/pdf-viewer.component.ts